import React, { createContext, useContext, useEffect, useState } from 'react';
import { getActiveTheme } from './themeUtils';
import { THEME_CONFIG } from './themeConfig'; // Ensure the path is correct

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  //const [activeTheme, setActiveTheme] = useState(getActiveTheme());
  const [activeTheme, setActiveTheme] = useState(
  getActiveTheme("summer"));
  //temporary
  const handleThemeChange = (themeKey) => {
  setActiveTheme({
    key: themeKey,
    ...THEME_CONFIG[themeKey]});
  };
  //temporary ends
  
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', activeTheme.key); // fix: was activeTheme.theme

    return () => {
      document.documentElement.removeAttribute('data-theme'); // fix: added cleanup
    };
  }, [activeTheme]);

  const changeTheme = (themeKey) => {
    setActiveTheme(getActiveTheme(themeKey));
  };

  return (
    <ThemeContext.Provider
      value={{
        activeTheme,
        changeTheme,
        handleThemeChange
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useSeasonalTheme = () => useContext(ThemeContext);